module.exports = __webpack_public_path__ + "img/explosion-particle-shadow.0319c9d9.png";